<div class="latestnews-wrapper">
  <div class="latestnews-container">
    <app-vertical-scroll-container>
      @for (item of items; track item.postId) {
      <app-latest-news-item [item]="item"></app-latest-news-item>
      }

      <div class="text-center">
        <a class="a-link" style="margin: 15px auto 0 auto; display: inline-block;" href="https://newscenter.isg-one.com" target="_blank">News Center</a>
      </div>
    </app-vertical-scroll-container>
  </div>
  <app-loading-indicator [isLoading]="isLoading"
                         [loadingMessage]="loadingMessage">

  </app-loading-indicator>
</div>
